import { Component, createRef } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Modal } from 'react-bootstrap';
import ArrowButton from '../button-arrow';
import { acceptPrivacy } from '../../../actions/user';
import { getPrivacyPolicy } from '../../../actions/content';

class PrivacyPopup extends Component {
  modalContainer = createRef();

  UNSAFE_componentWillMount() {
    const {show, dispatch} = this.props;
    if (show) {
      dispatch(getPrivacyPolicy());
    }
  }

  onConfirm() {
    const {dispatch} = this.props;

    dispatch(acceptPrivacy())
      .then(() => {
        try {
          dispatch({
            type: 'TOGGLE_PRIVACY_MODAL',
            payLoad: false
          });
        } catch (error) { //
          // swallowed modal lib bug error
        }
      });
  }

  render() {
    const { content, show } = this.props;

    return (
      <div className="container-fluid" ref={this.modalContainer}>
        <Modal
          animation={false}
          container={this.modalContainer.current}
          show={show}
        >
          <Modal.Header>
            <Modal.Title>
              Our Privacy Policy has been updated
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content)}}
              style={{
                overflowY: 'auto',
                maxHeight: window.innerHeight / 2
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <ArrowButton
              arrow={false}
              className="float-end"
              color="red"
              onClick={() => this.onConfirm(true)}
              submit={false}
            >
              Close
            </ArrowButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

PrivacyPopup.propTypes = {
  show: PropTypes.bool
};

PrivacyPopup.defaultProps = {
  show: false,
};

export default connect(state => ({
  content: state.privacyPolicy.content
}))(PrivacyPopup);
